import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import store from "./stores/index";
import routes from "@/router";
import "@/vee-validate";
import "@/mixins";
import { i18n } from "@/i18n-init";

import "bootstrap/dist/js/bootstrap.min.js";
window.$ = window.jQuery = require("jquery");

import VueMask from "v-mask";
Vue.use(VueMask, {
  placeholders: {
    N: /^[^0-9_!@#$%^&*()\-=+{}[\]\\/\\`'~?,:"<>|]+$/,
  },
});

new Vue({
  store,
  i18n,
  router: routes,
  render: (h) => h(App),
}).$mount("#app");

if (process.env.NODE_ENV === "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
  Vue.config.productionTip = true;
} else {
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false;
}
